const SITE_URL_ENV_KEY = 'VITE_SITE_URL';

type SiteUrlSource = 'env' | 'window';

const stripTrailingSlash = (value: string): string => {
  if (value.endsWith('/')) {
    return value.slice(0, -1);
  }
  return value;
};

const normalizeBaseUrl = (value: string, source: SiteUrlSource): string => {
  try {
    const normalized = new URL(value).toString();
    return stripTrailingSlash(normalized);
  } catch (error) {
    console.error('[site-url] Invalid base URL', { source, value, error });
    throw new TypeError(
      `${SITE_URL_ENV_KEY} must be a fully qualified URL (e.g. https://example.com)`
    );
  }
};

const readEnvSiteUrl = (): string | null => {
  const envValue = import.meta.env[SITE_URL_ENV_KEY as keyof ImportMetaEnv];

  if (typeof envValue !== 'string') {
    return null;
  }

  const trimmedValue = envValue.trim();

  if (trimmedValue.length === 0) {
    return null;
  }

  return trimmedValue;
};

const resolveWindowOrigin = (): string => {
  if (typeof window === 'undefined' || !window.location || !window.location.origin) {
    console.error('[site-url] window location is unavailable while resolving site URL');
    throw new ReferenceError(
      `${SITE_URL_ENV_KEY} must be set when window.location.origin cannot be read`
    );
  }

  return window.location.origin;
};

export const resolveSiteUrl = (): string => {
  const envUrl = readEnvSiteUrl();

  if (envUrl) {
    return normalizeBaseUrl(envUrl, 'env');
  }

  const windowOrigin = resolveWindowOrigin();
  return normalizeBaseUrl(windowOrigin, 'window');
};


